import { createFileRoute } from '@tanstack/react-router'
import AdminPlansPage from '@/components/pages/Admin/AdminPlansPage/AdminPlansPage'

export const Route = createFileRoute('/$workspaceName/$environment/admin/plans')({
  component: AdminPlansRoute,
})

function AdminPlansRoute() {
  return <AdminPlansPage />
}
